import { useNavigate, useLocation } from 'react-router-dom'
import EntitiesSort from './EntitiesSort'
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'ui/InputSelect'
import { Sort, ImpactType, Scope } from 'util/constants'

interface Props {
    sort: Sort
    searchParams: URLSearchParams
}

const ImpactsListSelector = ({ sort, searchParams }: Props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const typeFilter = searchParams.get('typeFilter') || 'All'
    const scopeFilter = searchParams.get('scopeFilter') || 'All'
    
    // Check if we're on the teabates page
    const isTeabatesPage = location.pathname.includes('/teabates')

    const handleSortChange = (newSort: Sort) => {
        const newSearchParams = new URLSearchParams(searchParams)
        const basePath = isTeabatesPage ? '/teabates' : '/impacts'
        navigate(`${basePath}/${newSort}?${newSearchParams.toString()}`)
    }

    const handleTypeChange = (newType: ImpactType) => {
        const newSearchParams = new URLSearchParams(searchParams)
        newSearchParams.set('typeFilter', newType ?? 'Type')
        const basePath = isTeabatesPage ? '/teabates' : '/impacts'
        navigate(`${basePath}/${sort}?${newSearchParams.toString()}`)
    }

    const handleScopeChange = (newScope: Scope) => {
        const newSearchParams = new URLSearchParams(searchParams)
        newSearchParams.set('scopeFilter', newScope ?? 'All')
        const basePath = isTeabatesPage ? '/teabates' : '/impacts'
        navigate(`${basePath}/${sort}?${newSearchParams.toString()}`)
    }

    return (
        <div className="flex gap-1 items-center">
            <EntitiesSort entityType={isTeabatesPage ? "teabate" : "impacts"} sort={sort} onSortChange={handleSortChange} />
            {!isTeabatesPage && (
                <Select value={scopeFilter && scopeFilter !== 'All' ? scopeFilter : 'All'} onValueChange={(value) => handleScopeChange(value as Scope)}>
                    <SelectTrigger className="px-3 py-2">
                        <SelectValue placeholder="Scope" />
                    </SelectTrigger>
                    <SelectContent>
                    {scopeFilter && scopeFilter !== 'All' ? <SelectItem value="All">Any Scope</SelectItem> : 
                        <SelectItem value="All">Scope</SelectItem>}
                        <SelectItem value="Local">Local</SelectItem>
                        <SelectItem value="National">National</SelectItem>
                        <SelectItem value="Global">Global</SelectItem>
                    </SelectContent>
                </Select>
            )}
            <Select value={typeFilter && typeFilter !== 'All' ? typeFilter : 'All'} onValueChange={(value) => handleTypeChange(value as ImpactType)}>
                <SelectTrigger className="px-3 py-2">
                    <SelectValue placeholder="Type" />
                </SelectTrigger>
                <SelectContent>
                    {typeFilter && typeFilter !== 'All' ? <SelectItem value="All">Any Type</SelectItem> : 
                    <SelectItem value="All">Type</SelectItem>}
                    <SelectItem value="impact_negative">Negative</SelectItem>
                    <SelectItem value="impact_positive">Positive</SelectItem>
                </SelectContent>
            </Select>
        </div>
    )
}

export default ImpactsListSelector